import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

declare let require: Function;



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'angular-9-i18n';
 
  constructor() {}
 
   public ngOnInit(): void { 
   }

}
